export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceFunctionName: "見守り機能",
      followSetting: {
        jingleFile: {
          fileName: "aaa.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        soundMessageFile: {
          fileName: "bbb.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        enqueteMessage: "アンケートメッセージ",
        enqueteAnswers: [
          {
            anwserNo: 1,
            answerMessage: "回答テキスト01",
            iconFile: {
              fileName: "01.png",
              contentType: "image/png",
              fileUri: "/images/img01.png",
              fileSize: 1024,
              thumbnailUri: "/images/img01.png"
            }
          },
          {
            anwserNo: 2,
            answerMessage: "回答テキスト02",
            iconFile: {
              fileName: "02.png",
              contentType: "image/png",
              fileUri: "/images/img01.png",
              fileSize: 1024,
              thumbnailUri: "/images/img01.png"
            }
          }
        ],
        messageAftAnswers: "回答後メッセージ"
      }
    }
  }
}